import { Form, Select, Spin } from 'antd';
import React, { Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import mask from '../../utils/mask';
import TitleFilter from '../TextFilter';
import { loadRequest } from 'store/ducks/depositante/actions';
import { Action } from 'typesafe-actions';
import { IDepositante } from 'store/ducks/depositante/types';

export const SelectDepositante: React.FC = () => {
  const { Option } = Select;
  const dispatch = useDispatch<Dispatch<Action>>();
  const depositantes = useSelector((state: ApplicationState) => state.Depositante.data);
  const loading = useSelector((state: ApplicationState) => state.Depositante.loading);
  const codCdd = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const parceiros = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);

  const onChangeParc = (values: any) => {
    localStorage.setItem(`codDepositante${window.location.pathname}`, values);
  };
  const localStorageItensPersist = localStorage.getItem(`codDepositante${window.location.pathname}`) || '';

  useEffect(() => {
    dispatch(loadRequest(Number(codCdd?.codCdd), parceiros));
  }, [dispatch, parceiros, codCdd]);

  const children: IDepositante[] | any = [];
  children.push(
    depositantes?.map((inscData) => (
      <Option
        title={inscData.nome}
        className="optionselect"
        value={inscData.codParc}
        key={inscData.codParc}
      >
        CNPJ/CPF: {mask('cpfCnpj', inscData.cnpjCpf)} <br />
        Inscrição estadual: {inscData.inscricaoEstadual} <br />
        Nome: {inscData.nome} - Código: {inscData.codParc}
        <hr />
      </Option>
    ))
  );

  return (
    <>
      <Form.Item label={<TitleFilter>Depositante</TitleFilter>} name="codDepositante">
        <Select
          data-cy="depositante"
          showSearch
          style={{ width: '100%' }}
          filterOption={(inputValue, element) =>
            element?.props.children
              .toString()
              .toLowerCase()
              .includes(inputValue.toLowerCase())
          }
          onChange={onChangeParc}
          defaultValue={localStorageItensPersist}
          loading={loading}
          notFoundContent={<Spin style={{ textAlign: "center", width: "100%" }} />}
        >
          {children}
        </Select>
      </Form.Item>
    </>
  );
};
